import { SdkMessageTypes } from '../constants';
import { HostedWebContentSdkService } from '../hosted-web-content-sdk';
import {
  IPageTabsService,
  TabInformation,
  TabInstance,
  TabInstanceParameters,
  ITelemetryScenario,
  ITelemetryService,
} from '../interfaces';
import { BaseMessageHandler } from './base-message-handler';
import { onStatusError } from './messageHandlingUtils';

/**
 * Responsible for pages.tabs module related message requests.
 */
export class PageTabsMessageHandler extends BaseMessageHandler {
  constructor(
    protected appSdkHost: HostedWebContentSdkService,
    protected pageTabsService?: IPageTabsService,
    protected telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }
  public initHandlers(): void {
    this.registerHandler(
      SdkMessageTypes.pages.tabs.navigateToTab,
      (_, params: TabInstance) => this.pageTabsService!.navigateToTab(params),
      {
        errorCallback: (error, scenario) => onStatusError(SdkMessageTypes.pages.tabs.navigateToTab, error, scenario),
      }
    );
    this.registerHandler(
      SdkMessageTypes.pages.tabs.getTabInstances,
      (_, params?: TabInstanceParameters) => this.pageTabsService!.getTabInstances(params),
      {
        errorCallback: (error, scenario) =>
          this.onGetTabsError(SdkMessageTypes.pages.tabs.getTabInstances, error, scenario),
      }
    );
    this.registerHandler(
      SdkMessageTypes.pages.tabs.getMruTabInstances,
      (_, params?: TabInstanceParameters) => this.pageTabsService!.getMruTabInstances(params),
      {
        errorCallback: (error, scenario) =>
          this.onGetTabsError(SdkMessageTypes.pages.tabs.getMruTabInstances, error, scenario),
      }
    );
  }

  protected validateDependencies() {
    if (!this.pageTabsService) {
      throw 'No pageTabsService provided';
    }
  }

  private onGetTabsError(apiName: string, error: any, scenario?: ITelemetryScenario): Promise<TabInformation> {
    scenario?.fail(`${apiName} failed ${error}`);
    return Promise.resolve({ teamTabs: [] });
  }
}
